import React from "react";
import "./Editgoal.css";
import { FaArrowLeft, FaCalendarAlt } from "react-icons/fa";

const Editgoal = () => {
  // Static mock-up of the goal form. Nothing on this page mutates the list, so
  // it is a plain constant rather than state with an unused setter.
  const interventions = [
    { id: 1, title: "Task Specific Training" },
    { id: 2, title: "Home Programme" },
  ];

  return (
    <main className="goal-container">
      <div className="header">
        <button className="back-btn" aria-label="Go to previous page">
          <FaArrowLeft className="icon" aria-hidden="true" /> Previous page
        </button>
      </div>

      <h1 className="page-title">Goal</h1>
      <p className="subtitle">Set your goal target here</p>

      <div className="goal-section">
        <div className="goal-header">
          <h3>
            Goals selected for <span className="name">James</span>
          </h3>
        </div>

        {/* Goal Info Section */}
        <div className="goal-grid">
          <div className="form-group">
            <label htmlFor="goal-domain-1">Goal Domain 1</label>
            <input type="text" id="goal-domain-1" defaultValue="Floor Mobility" />
          </div>
          <div className="form-group">
            <label htmlFor="target-date">Target Date</label>
            <div className="date-inputco" role="button" tabIndex="0" onClick={() => document.getElementById('target-date')?.showPicker()} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.getElementById('target-date')?.showPicker(); } }} aria-label="Target Date">
              <span className={document.getElementById('target-date')?.value || !"2025-10-22" ? "filled" : "placeholder"}>
                {(() => {
                  const v = document.getElementById('target-date')?.value || "2025-10-22";
                  const d = new Date(v);
                  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
                })()}
              </span>
              <FaCalendarAlt className="calendar-icon1" aria-hidden="true" />
              <input type="date" id="target-date" defaultValue="2025-10-22" aria-label="Target Date" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="status">Status</label>
            <select id="status">
              <option>Select</option>
              <option>Active</option>
              <option>Completed</option>
              <option>In Progress</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="result-date">Result Date</label>
            <div className="date-inputco" role="button" tabIndex="0" onClick={() => document.getElementById('result-date')?.showPicker()} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.getElementById('result-date')?.showPicker(); } }} aria-label="Result Date">
              <span className="placeholder">Select date</span>
              <FaCalendarAlt className="calendar-icon1" aria-hidden="true" />
              <input type="date" id="result-date" aria-label="Result Date" />
            </div>
          </div>
        </div>

        {/* SMART Goal */}
        <div className="form-group full">
          <label htmlFor="smart-goal">Caregiver-led SMART goal</label>
          <input type="text" id="smart-goal" placeholder="Type here..." />
        </div>

        {/* Caregiver intervention */}
        <div className="form-group full">
          <label htmlFor="intervention">What intervention(s) has been selected by caregiver(s)?</label>
          <select id="intervention">
            <option>Select</option>
            <option>Mobility Training</option>
            <option>Balance Exercises</option>
            <option>Stretching Program</option>
          </select>
        </div>

        {/* Intervention Sections */}
        {interventions.map((item) => (
          <div key={item.id} className="intervention-card">
            <h4>
              {item.id}. {item.title}
            </h4>

            <div className="form-group full">
              <label htmlFor="intervention-dose">
                What dose of intervention have you recommended to achieve this
                goal?
              </label>
              <select id="intervention-dose">
                <option>Select</option>
                <option>High Intensity</option>
                <option>Moderate Intensity</option>
                <option>Low Intensity</option>
              </select>
            </div>

            <div className="dose-grid">
              <div className="form-group">
                <label htmlFor="sessions-day">No. of sessions per day</label>
                <input type="number" id="sessions-day" min="0" />
              </div>
              <div className="form-group">
                <label htmlFor="sessions-week">No. of minutes per session</label>
                <input type="number" id="sessions-week" min="0" />
              </div>
              <div className="form-group">
                <label htmlFor="sessions-month">No. of months</label>
                <input type="number" id="sessions-month" min="0" />
              </div>
            </div>
          </div>
        ))}

        {/* Mechanism of Action */}
        <fieldset style={{ border: 'none', padding: 0 }}>
          <legend>Does the mechanism of action of the intervention align with the goal and priority goal limiting factors?</legend>
          <div className="radio-group">
            <label>
              <input type="radio" name="align" /> Yes
            </label>
            <label>
              <input type="radio" name="align" /> No
            </label>
          </div>
        </fieldset>

        {/* Outcome Measure */}
        <div className="form-group full">
          <label htmlFor="outcome-measure">What outcome measure are you using?</label>
          <input type="text" id="outcome-measure" placeholder="Type here" />
        </div>

        <div className="update-btn-container">
          <button className="update-btn" aria-label="Update goal">Update</button>
        </div>
      </div>
    </main>
  );
};

export default Editgoal;
